import React, { useState } from 'react';
import { HandySvg } from "handy-svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/authProvider/AuthContext";

import visible from "./img/visible.svg";
import invisible from "./img/invisible.svg";
import anixLogo2 from "./img/anixLogo.png"

import "./StyleUsAuth.css"
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import NewPasswordPopUp from "./NewPassword/NewPasswordPopUp";

const Auth = () => {
    const navigate = useNavigate();
    const { login, getRedirectPath } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [isOpenNewPassword, setIsOpenNewPassword] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        login: '',
    });

    const openPopUpNewPassword = () => setIsOpenNewPassword(true);
    const closePopUpNewPassword = () => setIsOpenNewPassword(false);

    const handleOpenAlert = (title, message) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => setIsOpenAlert(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        const trimmedValue = value.includes('@')
            ? value.slice(0, value.indexOf('@'))
            : value;

        setFormData({
            ...formData,
            [name]: trimmedValue.trim(),
        });
    };

    const handleSignIn = async () => {
        const result = await login(formData);

        if (result.success) {
            const redirectPath = getRedirectPath(result.roles);
            navigate(redirectPath);
        } else {
            handleOpenAlert('Ошибка', result.error || "Не удалось выполнить вход. Проверьте вводимые данные и попробуйте снова");
        }
    };

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    return (
        <div className="wrapper_container_auth auth__wrapper__active" id="auth">
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
            />
            <NewPasswordPopUp
                isOpenPopUp={isOpenNewPassword}
                onClosePopUp={closePopUpNewPassword}
            />
            <div className="container_auth">
                <div className="wrapper_img">
                    <img src={anixLogo2} alt='Лого "АНИКС"'/>
                    <p>Единый сервис авторизации</p>
                </div>
                <form id="form_login">
                    <div className="wrapper_input">
                        <input className="default_input"
                               type="text"
                               id="login"
                               name="login"
                               autoComplete="new-password"
                               autoCorrect="off"
                               autoCapitalize="none"
                               placeholder="Логин/Телефон..."
                               required
                               onChange={handleChange}
                        />
                    </div>
                    <div className="wrapper_input">
                        <input className="default_input"
                               type={showPassword ? 'text' : 'password'}
                               id="password"
                               name="password"
                               autoComplete="new-password"
                               autoCorrect="off"
                               autoCapitalize="none"
                               placeholder="Пароль..."
                               required
                               onChange={handleChange}
                        />
                        <HandySvg
                            src={showPassword ? visible : invisible}
                            className="toggle__show"
                            onClick={togglePasswordVisibility}
                        />
                    </div>
                    <button className="default_button but_new_password" type="button" onClick={openPopUpNewPassword}>
                        Получить доступ?
                    </button>
                    <div className="wrapper_button">
                        <button className="default_button" type="button" onClick={handleSignIn}>
                            Войти
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Auth;